export const TITLE_TEXT = 'Количество пометок меньше, чем количество'
export const TITLE_TEXT_WARNING =
  'Человек с таким именем может быть однофамильцем или тезкой человека из списка иноагентов или экстремистов:'
export const TITLE_INOAGENT = 'иноагентов:'
export const TITLE_EXTREMIST = 'экстремистов:'
